<i18n>
{
	"en": {
		"title": "Incoterms Postal Place"
	},
	"no": {
		"title": "Incoterms poststed"
	}
}
</i18n>

<template>
	<div>
		<t-combobox-button
			:title="$t('title')"
			icon="geosearch"
			:showCount="false"

			:searchValue="searchValue"
			:items="items"
			:selected="value"

			:disabled="disabled"
			buttonDisabled

			@focus="onFocus"
			@input="onInput"
			@blur="onBlur"
			@change="onChange"
		>
			<template v-slot:optionItemContent="slotProps">
				<div class="item">
					<div class="item-main-text">{{ slotProps.item.postalPlace }}</div>
				</div>
			</template>
		</t-combobox-button>
	</div>
</template>

<script>
import { mapActions } from '@/modules/incoterms/store/incoterms.store';
import TComboboxButton from '@/components/evergreen/timpex/inputs/TComboboxButton';

export default {
	name: 'IncotermsPostalPlaceInput',
	components: { TComboboxButton },
	props: {
		value: Object,
		disabled: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			items: [],
			searchValue: '',
			lastSearch: null,
			searchTimeout: null,
			focused: false,
		};
	},
	watch: {
		value: {
			immediate: true,

			handler(value) {
				this.searchValue = this.getSearchValueFromValue(value);
			}
		}
	},
	methods: {
		...mapActions(['getFilteredGlobalUniquePostalPlaces']),

		onFocus() {
			this.focused = true;
		},
		onInput(searchValue) {
			this.dirty = true;

			this.searchValue = searchValue;

			if (this.shouldCancelNewSearch(searchValue, this.lastSearch, this.items))
				return;

			clearTimeout(this.searchTimeout);
			this.searchTimeout = setTimeout(() => {

				this.search(searchValue);

			}, 250);
		},
		shouldCancelNewSearch(searchValue, lastSearch, items) {
			return (
				searchValue === ''
				|| (
					items.length < this.$options.SERVER_RETURN_LIMIT
					&& searchValue.startsWith( lastSearch )
				)
			);
		},
		onChange(value) {

			this.searchValue = this.getSearchValueFromValue(value);

			this.$emit('change', value);
		},
		onBlur() {
			this.focused = false;

			if (
				this.value
				&& ( this.value.id || this.value.name || this.value.postalPlace || this.value.postalCode )
				&& this.searchValue === ''
			)
				this.$emit('change', {});

			else
				this.searchValue = this.getSearchValueFromValue(this.value);
		},
		async search(searchValue) {
			try {
				this.items = await this.getFilteredGlobalUniquePostalPlaces(searchValue);

				if (
					!this.focused
					&& this.items
					&& this.items.length === 1
				) {
					this.$emit('change', this.items[0]);
					this.searchValue = this.getSearchValueFromValue(this.items[0]);
				}
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('failedToFetch')
				});
			}
			this.lastSearch = searchValue;
		},
		getSearchValueFromValue(value) {

			if (value && value.postalPlace && value.postalPlace.length)
				return value.postalPlace;
			else
				return '';
		},
	},
};
</script>
